/**
 * Helper para diagnosticar qué requisitos faltan para realizar una acción
 */

export const checkEnrollmentRequirements = (data) => {
  const {
    students = [],
    disciplines = [],
    groups = [],
    levels = []
  } = data;

  const requirements = [
    {
      text: 'Al menos un estudiante registrado',
      completed: students.length > 0,
      action: students.length === 0 ? '/students?action=create' : null,
      actionLabel: 'Crear Estudiante',
      key: 'students'
    },
    {
      text: 'Al menos una disciplina creada',
      completed: disciplines.length > 0,
      action: disciplines.length === 0 ? '/disciplines?action=create' : null,
      actionLabel: 'Crear Disciplina',
      key: 'disciplines'
    },
    {
      text: 'Al menos un nivel configurado',
      completed: levels.length > 0,
      action: levels.length === 0 ? '/levels?action=create' : null,
      actionLabel: 'Crear Nivel',
      key: 'levels'
    },
    {
      text: 'Al menos un grupo activo',
      completed: groups.length > 0,
      action: groups.length === 0 ? '/groups?action=create' : null,
      actionLabel: 'Crear Grupo',
      key: 'groups'
    }
  ];

  const allMet = requirements.every(req => req.completed);
  const pending = requirements.filter(req => !req.completed);

  return {
    requirements,
    allMet,
    pending,
    count: {
      total: requirements.length,
      completed: requirements.filter(r => r.completed).length,
      pending: pending.length
    }
  };
};

export const checkGroupRequirements = (data) => {
  const {
    disciplines = [],
    levels = []
  } = data;

  const requirements = [
    {
      text: 'Al menos una disciplina creada',
      completed: disciplines.length > 0,
      action: disciplines.length === 0 ? '/disciplines?action=create' : null,
      actionLabel: 'Crear Disciplina',
      key: 'disciplines'
    },
    {
      text: 'Al menos un nivel configurado',
      completed: levels.length > 0,
      action: levels.length === 0 ? '/levels?action=create' : null,
      actionLabel: 'Crear Nivel',
      key: 'levels'
    }
  ];

  const allMet = requirements.every(req => req.completed);
  const pending = requirements.filter(req => !req.completed);

  return {
    requirements,
    allMet,
    pending,
    count: {
      total: requirements.length,
      completed: requirements.filter(r => r.completed).length,
      pending: pending.length
    }
  };
};

export const diagnoseMissingGroups = (selectedDiscipline, selectedLevel, allGroups, enrolledGroupIds) => {
  const reasons = [];
  
  if (!selectedDiscipline || !selectedLevel) {
    reasons.push('Debes seleccionar una disciplina y un nivel primero');
  } else {
    const matchingGroups = allGroups?.filter(group => 
      group.discipline_id === selectedDiscipline.id &&
      group.level_id === selectedLevel.id &&
      group.is_active === true
    ) || [];

    if (matchingGroups.length === 0) {
      reasons.push(`No se ha creado ningún grupo para "${selectedDiscipline.name}" - "${selectedLevel.name}"`);
      reasons.push('Los grupos existentes pueden estar inactivos');
    } else {
      const availableGroups = matchingGroups.filter(g => !enrolledGroupIds.includes(g.id));
      if (availableGroups.length === 0) {
        reasons.push('El estudiante ya está matriculado en todos los grupos disponibles');
        reasons.push('Los grupos pueden estar llenos');
      }
    }
  }

  return reasons;
};

